<template>
	<div class="hello" style="background-color: #f6f6f6;">
		
		<div class="header">
			<div @click="backJump" style="color: #fff;padding-top: 10px;margin-left: 10px;">
				<span style="line-height: 30px;"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span>
			</div>
			<div class="clear"></div>
			<img src="../assets/topback.png" style="width: 50%;height: 75%;float: right;margin-top: -10px;" alt="">
			<div>
				<h2><span>缴</span>费账单</h2>
			</div>
		</div>
		
		<div class="center" style="position: relative;">
			<div class="center-top">
				<div class="up">
					<div class="bt">
						<img src="../assets/water.png" >
						<span>水费</span>
					</div>
					<div style="border-bottom: 1px solid #dee1e5;height: 35px;">
						<span style="color: #8e8e8e;float: left;">剩余水量：</span><span style="float: right;"><span style="font-size: 22px;">{{bhdy}}</span>(元)</span>
					</div>
					<div class="clear"></div>
					<div style="float: right;">
						<p style="font-size: 12px;">
							数据更新时间：{{date}}
						</p>
					</div>
						
					</div>
				</div>
				
			<div class="center_auto">
				<div class="zj">
					<div class="botder">
						<span class="left">识别编码信息</span><span class="right">{{trans.houseHoldNumber}}</span>
					</div>
					<div style="height:80px;border-bottom:1px solid #DEE1E5;line-height:40px">
						<div><div class="left">住址信息</div><br><div>{{trans.actName}}</div></div>
					</div>
				</div>
				
			</div>
			<div class="center_bottom">
				<div class="down">
					<p style="color: #0F72DD;">缴费金额</p>
					<div class="allin">
						<van-button type="info" @click="backchange(1)" :style="colorone" style="width: 40%;">100元</van-button>
						<van-button type="info" @click="backchange(2)" :style="colortwo" style="width: 40%;">200元</van-button>
						<van-button type="info" @click="backchange(3)" :style="colorthree" style="width: 40%;">300元</van-button>
						<van-button type="info" @click="backchange(0)" :style="colorzero" style="width: 40%;">自定义金额</van-button>
					</div>
					<div :style="inputmonenone">
						<van-field v-model="price" type="number" label="¥" />
					</div>
				</div>
			</div>
			<van-button type="primary" @click="goJump" style="width: 90%;margin: 30px auto;background-color: #2D86F6;border-radius: 10px;font-size: 16pt;letter-spacing: 1px;height: 50px;" block>立即缴费</van-button>
			
		</div>
		<div class="foot">
			<div class="bot">
				<p style="color:#0f72dd">缴费服务</p>
				
				<div style="border-bottom:1px solid #8e8e8e;height: 70px;margin-top: 35px;">
					<img src="../assets/money.png" style="width:50px;float:left; 50px;" alt="">
					<div style="margin-left: 60px;">
						<span>缴费记录</span>
						<button @click="payment" style="border: none;width:80px;border-radius: 50px;background-color: #0f72dd;color:#fff;height:30px;line-height: 30px;float: right;margin-top: 10px;">进入</button>
						<p>可查询每笔缴费记录</p>
					</div>
					
				</div>
				<div>
					<img src="../assets/jil.png" style="width:50px;float:left; 50px;" alt="">
					<div style="margin-left: 60px;">
						<span>用量记录</span>
						<button @click="balance" style="border: none;width:80px;border-radius: 50px;background-color: #0f72dd;color:#fff;height:30px;line-height: 30px;float: right;margin-top: 10px;">进入</button>
						<p>日报、周报、月报</p>
					</div>
					
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import wx from 'weixin-js-sdk';
  import { content, seriou, waterVolume } from '../common/api/watmentw'
import jump from "../common/jump";
	export default {
	  data() {
	    return {
			colorone:{
				backgroundColor: '#2D86F6',height: '25pt',borderRadius: '5px',
			},
			colortwo:{
				backgroundColor: '#8e8e8e',height: '25pt',borderRadius: '5px',marginLeft: '50px',
			},
			colorthree:{
				backgroundColor: '#8e8e8e',height: '25pt',borderRadius: '5px',
			},
			colorzero:{
				backgroundColor: '#8e8e8e',height: '25pt',borderRadius: '5px',marginLeft: '50px',
			},
			inputmonenone:{display:'none',marginTop: '30px',height: '26px',borderBottom: '1px solid #dee1e5'},
			price: 100,
			payType: 1,
			phone: "18595562877",
			devAddress: "",
			mchId: "1",
			useType: 1,
			date:'2021年12月7日16:20分',
			bhdy:'1.03',
		    content:'',
			number:'',
			order:'',
			orderNo:'',
			trans:[]
	    };
	  },
	  mounted() {
      content({houseHoldNumber : this.$route.query.phone}).then((response)=>{
        this.trans = response.data.items[0]
        seriou(this.trans.devId).then((response)=>{
          this.bhdy = response.data.surplusAmount
          this.date = response.data.time
        })
		  })
	  },
	  methods:{
      backJump(){
        this.$destroy()
        jump.$emit('back')
        this.$router.go(-1)
      },
		  goJump() {
        console.log(this.price)
        var data = JSON.stringify({
          "price": this.price,
          "devId": this.trans.devId,
          "houseHoldNumber": this.trans.houseHoldNumber,
          "payType": this.payType,
          "phone": this.trans.phone,
          "devAddress": this.trans.actName,
          "useType": 1,
          "mchName": this.trans.mchName,
          "mchNumber": this.trans.mchNumber,
          "type": 1,
          "tenantId": this.trans.tenantId,
          "productId":this.trans.productId,
          "payment":this.trans.payType
        });
        console.log(data)
        waterVolume(data).then((res) => {
          this.jsap(res.data.orderNo, this.trans.devType)
        })
		  },
      jsap(orderNo,devType){
        console.log(orderNo)
        this.typ = window.__wxjs_environment
        var isWxMini = window.__wxjs_environment === 'miniprogram'     // 判断场景是否小程序
        const url = '/pages/logs/logs?orderNo='+orderNo +'&token=' + this.$cookies.get("token") + '&devType=' + devType
        console.log(url)
        if (isWxMini) {
          this.typ = "11跳转"
          wx.miniProgram.navigateTo({
            url: url
          });
        } else {
          this.$toast('请在微信端重新操作')
        }
      },
		  payment(){
        this.$router.push({path:'/payment',query:{houseHold:this.trans.houseHoldNumber}})
		  },
		  balance(){
			  this.$router.push({path:'/wateragain',query:{houseHold:this.trans.houseHoldNumber,address:this.trans.actName}})
		  },
		  backchange(much){
			  switch (much){
				  case 1:
				  console.log(1)
				  this.colorone.backgroundColor='#2D86F6',
				  this.colortwo.backgroundColor='#8e8e8e',
				  this.colorthree.backgroundColor='#8e8e8e',
				  this.colorzero.backgroundColor='#8e8e8e',
				  this.inputmonenone.display='none'
				  
				  this.price = 100
				  break;
				  case 2:
				  console.log(2)
				  this.colorone.backgroundColor='#8e8e8e',
				  this.colortwo.backgroundColor='#2D86F6',
				  this.colorthree.backgroundColor='#8e8e8e',
				  this.colorzero.backgroundColor='#8e8e8e',
				  this.inputmonenone.display='none'
				  
				  this.price = 200
				  break;
				  case 3:
				  console.log(3)
				  this.colorone.backgroundColor='#8e8e8e',
				  this.colortwo.backgroundColor='#8e8e8e',
				  this.colorthree.backgroundColor='#2D86F6',
				  this.colorzero.backgroundColor='#8e8e8e',
				  this.inputmonenone.display='none'
				  
				  this.price = 300
				  break;
				  case 0:
				  console.log(0)
				  this.colorone.backgroundColor='#8e8e8e',
				  this.colortwo.backgroundColor='#8e8e8e',
				  this.colorthree.backgroundColor='#8e8e8e',
				  this.colorzero.backgroundColor='#2D86F6',
				  this.inputmonenone.display='block'
				  
				  this.price=""
				  break;
			  }
			  
		  }
	  }
	};
</script>

<style scoped>
	.clear{
		clear: both;
	}
	.header{
		width: 100%;
		height: 192px;
		background-color: #295ad0;
	}
	
	.header h2{
		letter-spacing:2px;
		color: rgb(255, 255, 255);
		line-height: 70px;
		position: relative;
		margin-left:20px
	}
	.header h2 span{
		border-bottom: 3px solid #fff;
	}
	.bt{
		height: 100px;
		margin-top:20px
	}
	
	.bt img{
		width: 38px;
		height:38px;
		float: left;
	}
	.bt span{
		line-height: 42px;
		margin-left: 10px;
		font-size: 20px;
	}
	.bt p {
		color:#0F72DD;
	}
	.center-top{
		width: 90%;
		margin: 0 auto;
		border: 1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 15px -5px;
		border-radius: 10px;
		margin-top: -15px;
		background-color: #fff;
	}
	.up{
		width: 80%;
		margin: 0 auto;
		height: 200px;
	}
	.center_auto{
		width: 90%;
		margin: 0 auto;
		border: 1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 15px -5px;
		border-radius: 10px;
		margin-top: -15px;
		background-color: #fff;
		margin-top: 30px;
	}
	.zj{
		width: 80%;
		margin: 0 auto;
		height: 200px;
		margin-top: 20px;
	}
	.zj .botder{
		height: 55px;
		border-bottom:1px solid #DEE1E5;
		line-height: 55px;
	}
	
	.left{
		float: left;
		color: #8e8e8e;
	}
	.right{
		float: right;
	}
	.center_bottom{
		width: 90%;
		margin: 0 auto;
		border: 1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 15px -5px;
		border-radius: 10px;
		margin-top: -15px;
		background-color: #fff;
		margin-top: 30px;
	}
	.down{
		width: 80%;
		margin: 0 auto;
		height: 230px;
		margin-top: 20px;
	}
	.down van-button{
		width: 30%;
	}
	.allin button{
		border: none;
	}
	.foot{
		width: 90%;
		border: 1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 15px -5px;
		border-radius: 10px;
		height:260px;
		margin: 0 auto;
		margin-top:30px;
		background-color: #fff;
	}
	.bot{
		width: 80%;
		margin: 0 auto;
		padding-top: 10px;
	}
	.bot div{
		margin-top:20px
	}
	.bot div p{
		font-size: 14px;
		color: #8e8e8e;
		font-family: 'PingFangSC-Medium';
		margin-top: 5px;
	}
</style>
